import {
  HouseOutlined,
  StyleOutlined,
  SupervisorAccount
} from '@mui/icons-material';
import { useOrganizationNavBarQuery } from 'generated/graphql';
import { authUtil } from 'modules/common';
import { CustomIcon } from 'modules/components/layer00';
import { NavBarItem } from 'modules/components/layer01';
import { Navbar } from 'modules/components/layer02';

import { useParams } from 'react-router-dom';


export type OrganizationNavbarProps = {};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: OrganizationNavbarProps) => {
  const params = useParams();
  const projectId = params.projectId ?? '';
  const queryTuple = useOrganizationNavBarQuery({
    variables: {
      id: projectId
    },
    skip: projectId === ''
  });


  const baseOrgRoute = '/organization/projects';
  const baseProjectRoute = `${baseOrgRoute}/${params.projectId}`;

  const navItems: NavBarItem.NavBarItemProps[] = [
    {
      path: `${baseProjectRoute}/dashboard`,
      icon: <HouseOutlined />,
      label: 'Dashboard'
    },
    {
      path: `${baseProjectRoute}/milestones`,
      icon: <CustomIcon.large.FC icon='CALENDARALT2' />,
      label: 'Milestones'
    },
    {
      path: `${baseProjectRoute}/tasks`,
      icon: <CustomIcon.large.FC icon='TASK' />,
      label: 'Tasks'
    },
    {
      path: `${baseProjectRoute}/dailyreports`,
      icon: <CustomIcon.large.FC icon='FILE' />,
      label: 'Daily Reports'
    },
    {
      path: `${baseProjectRoute}/installations`,
      icon: <StyleOutlined />,
      label: 'Finishes'
    },
    {
      path: `${baseProjectRoute}/planSets`,
      icon: <CustomIcon.large.FC icon='PLAN' />,
      label: 'Plans'
    },
    {
      path: `${baseProjectRoute}/files`,
      icon: <CustomIcon.large.FC icon='FOLDERALT' />,
      label: 'Files'
    },
    {
      path: `${baseProjectRoute}/clientreports`,
      icon: <CustomIcon.large.FC icon='FOG' />,
      label: 'Client Reports'
    },
    {
      path: `${baseProjectRoute}/team`,
      icon: <CustomIcon.large.FC icon='TEAM' />,
      label: 'Team'
    },
    {
      path: `${baseOrgRoute}`,
      icon: <CustomIcon.large.FC icon='SHOP' />,
      label: 'Projects'
    },
    {
      icon: <CustomIcon.large.FC icon='PASSPORT' />,
      label: 'Profile',
      path: `/organization/projects/${params.projectId}/profile`
    }
  ];

  if (queryTuple.data?.loggedInUser?.isSuperAdmin) {
    navItems.push(...[
      {
        path: '/superAdmin',
        icon: <SupervisorAccount />,
        label: 'Super Admins'
      },
      {
        path: '/superAdmin/standardareainstallations',
        icon: <CustomIcon.large.FC icon='SPARKLE' />,
        label: 'Template Selections'
      }
    ]);
  }
  return (
    <>
      <Navbar.FC
        workSpaceItems={navItems}
        projectName={queryTuple.data?.project?.name ?? ''}
        bottomBottom={{
          icon: <CustomIcon.large.FC icon='DOOR' />,
          label: 'Log Out',
          path: `/organization/projects/${params.projectId}/profile`,
          onClick: () => {
            authUtil.signOut();
          }
        }}
      />
    </>
  );
};
